module.exports = __webpack_public_path__ + "img/huawei.d16c93dd.png";